// @flow

import React from 'react';
import { Segment, Dimmer, Loader } from 'semantic-ui-react';

type Props = {
  title: string,
};

const styles = {
  loader: {
    minHeight: '140px',
  },
};

export const ListLoader = ({ title }: Props) => {
  return (
    <Segment style={styles.loader}>
      <Dimmer active inverted>
        <Loader
          indeterminate
          size="big"
          content="Chargement des conversations..."
        />
      </Dimmer>
    </Segment>
  );
};



// WEBPACK FOOTER //
// ./src/modules/messaging/components/shared/ListLoader.js